import { render, staticRenderFns } from "./index.vue?vue&type=template&id=d6617650&"
import script from "./index.component.ts?vue&type=script&lang=ts&"
export * from "./index.component.ts?vue&type=script&lang=ts&"
import style0 from "./index.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\opusb-web-myactio\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d6617650')) {
      api.createRecord('d6617650', component.options)
    } else {
      api.reload('d6617650', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=d6617650&", function () {
      api.rerender('d6617650', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/shared/components/ChatRoom/index.vue"
export default component.exports